// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInline-cls1_iXN","cls2":"CiterightInline-cls2_4EG CiterightInline-cls1_iXN"};